'use strict';
angular.module('newspaperSignedDraftModule', [
    'newspaperSignedDraftRouterModule',
]).controller('newspaperSignedDraftCtrl', [
    '$scope',
    '$stateParams',
    '$state',
    '$window',
    '$cacheFactory',
    '$q',
    '$filter',
    'trsHttpService',
    'initSingleSelecet',
    'editNewspaperService',
    'trsspliceString',
    'editingCenterService',
    'editcenterRightsService',
    'trsPrintService',
    'localStorageService',
    'modalDialog',
    'storageListenerService',
    'editIsLock',
    'messagePublishService',
    'newMediaService',
    'publicToolService',
    function ($scope,
        $stateParams,
        $state,
        $window,
        $cacheFactory,
        $q,
        $filter,
        trsHttpService,
        initSingleSelecet,
        editNewspaperService,
        trsspliceString,
        editingCenterService,
        editcenterRightsService,
        trsPrintService,
        localStorageService,
        modalDialog,
        storageListenerService,
        editIsLock,
        messagePublishService,
        newMediaService,
        publicToolService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                'CURRPAGE': 1,
                'PAGESIZE': 50,
                'ITEMCOUNT': 0,
                'PAGECOUNT': 0
            };
            $scope.childStatus = {
                // 图片数组的string
                checkString: 'DOC_PICTURELIST',
                // 图片数组中表示url地址的string
                picString: 'SRCPICURL',
                originPicUrl: 'SRCPICURL'
            };
            $scope.params = {
                'serviceid': 'mlf_paper',
                'methodname': 'queryYiQianDocs',
                'paperid': $stateParams.paperid,
                // 'DocPubTime': '1m',
                'DocType': '',
                'DocStatus': ''
                // PAGEINDEX: $scope.page.CURRPAGE,
            };
            $scope.status = {
                isShowList: true,
                isESSearch: false,
                isMorePanelShow: false,
                message: {
                    currUnreadNum: 0, // 当前未读信息数
                    systemTime: '', // 缓存最近请求时间
                },
                batchOperateBtn: {
                    'hoverStatus': '',
                    'clickStatus': ''
                },
                btnRights: '',
                isOpenedPanel: {
                    0: true
                }, // 第一个版面打开
                cachedName: 'newspaperSignedDocuments',
                cachedPage: {},
                cacheOpenedPanel: {},
                cacheOpenedPanelKey: 'yqg',
                selectAllBtn: [{
                    hasBtn: true,
                }],
                hasphoto: false, // 是否是图集稿
                hasphotoflag: true, // 判断是否人为点击图集切换模式
                yqgpreview: 3,
                newspaperEdit: editNewspaperService.initNewspaperEdit(),
                yqedit: 3
            };
            $scope.data = {
                panels: [],
                selectedArray: [],
                newspaperUrl: {
                    1: 'newspaperpic',
                    2: 'newspapertext'
                },
                newspaperPreview: {
                    1: 'newspaperNewsPreview',
                    2: 'newspaperAtlasPreview'
                },
                BanMian: {
                    selectedBanMian: {},
                    BanMianArray: [],
                },
                word: [],
                signerArr: [],
                AllBMRights: {}, // 所有的权限都记录在这个地方 
                // 这里用于给时间指令传自定义的配置
                customConfig: {
                    singleDatePicker: true, // 是否是单选框
                },
                orderArray: editingCenterService.getNewspaperOrder(), // 下拉框排序
                selectedOrder: editingCenterService.getNewspaperOrder()[0],
            };

        }

        /**
             * [initData description]初始化数
             *
             * @return  {[type]}  [return description]
             */
        function initData() {
            initDropDown();
            // requestData();
            editcenterRightsService.initNewspaperListBtn('paper.yqg', $stateParams.paperid).then(function (data) {
                $scope.status.btnRights = data;
                $scope.data.AllBMRights['paper.yqg'] = data;
            });
            editingCenterService.getSiteInfo($stateParams.paperid).then(function (data) {
                $scope.data.paperMsg = data;
                editNewspaperService.screenFilter($state.params.paperid, $scope.data.paperMsg.ISZHAOPAI === '1').then(function (data) {
                    $scope.data.BanMian.BanMianArray = data;
                    $scope.data.BanMian.selectedBanMian = data[0];
                });
            });
            listenStorage();
        }

        // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
        $scope.requestData = function () {
            publicToolService.getModeconfiguration('newspaperDefaultOrderByTime').then((config) => {
                $scope.data.selectedOrder = (config === 'true' ? editingCenterService.getNewspaperOrder()[1] : editingCenterService.getNewspaperOrder()[0]);
                requestData();
            },
            () => {
                requestData();
            });
        };

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenNewspaper(function () {
                requestData();
                storageListenerService.removeListener('newspaper');
            }, $scope);
            $scope.$on('$destroy', function () {
                localStorageService.remove('newspaperPreviewSelectArray');
                localStorageService.remove('newspaperPreviewCache');
            });
        }

        /**
         * [requestData description]数据请求函数
         * @param  {Boolean} isGetMorePanel [description] 是否加载更多panel，用于点击筛选全部日期的稿件时
         * @return {[type]}                 [description]
         */
        function requestData(isGetMorePanel) {
            var deferred = $q.defer();
            // 判断是否启用ES检索
            var params = $scope.status.isESSearch ? getESSearchParams() : angular.copy($scope.params);
            if ($scope.status.isShowList) {
                params.PageSize = $scope.page.PAGESIZE;
                params.PAGEINDEX = $scope.page.CURRPAGE;
                if (!$scope.status.isESSearch) {
                    params.NoPage = !$scope.status.isESSearch && $scope.status.isShowList;
                    params.ChannelId = $scope.data.BanMian.selectedBanMian.CHANNELID;
                }
            } else {
                params.ChannelId = '';
            }
            params.OrderType = $scope.data.selectedOrder.value;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.selectedArray = [];
                var fileterObj = {};
                if ($scope.status.isShowList) {
                    $scope.data.selectAllWords = 0;
                    $scope.data.items = $scope.data.panels = data.DATA;
                    // 在请求到数据以后再更换图集模式
                    if ($scope.data.selectedDocType.value && $scope.data.selectedDocType.value === '2' && $scope.status.hasphotoflag === true) {
                        $scope.status.hasphoto = true;
                    } else {
                        $scope.status.hasphoto = false;
                    }
                    $scope.page = data.PAGER;
                    fileterObj = editNewspaperService.extractParametersList(data.DATA, {
                        namekey: 'OPERNAME',
                        valuekey: 'OPERUSER',
                        title: '签发人'
                    });
                    $scope.data.signerArr = $scope.data.signerArr.concat(fileterObj.nameArr);
                    $scope.data.signerArr = $filter('unique')($scope.data.signerArr, 'name');
                    editNewspaperService.liebiaoListItemCache(data.DATA);
                } else {
                    $scope.status.hasphoto = false;
                    fileterObj = editNewspaperService.extractParameters(data, {
                        namekey: 'OPERNAME',
                        valuekey: 'OPERUSER',
                        title: '签发人'
                    });
                    $scope.data.signerArr = fileterObj.nameArr;
                    $scope.data.signerArr = $filter('unique')($scope.data.signerArr, 'name');
                    cacheDate(data);
                    if (data.length > 0) {
                        $scope.data.word = editNewspaperService.getWordNum(data);
                        openDefaultPanels();
                        $scope.status.isMorePanelShow = true;
                    } else {
                        $scope.status.isMorePanelShow = false;
                    }
                }
                if (!$scope.data.selectedSigner) {
                    $scope.data.selectedSigner = $scope.data.signerArr[0];
                }
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [openDefaultPanels description]  打开默认的PANEL
         * @return {[type]} [description]
         */
        function openDefaultPanels() {
            // var flag = true;
            var tempOpenedPanels = editNewspaperService.getCacheOpenedPanel($scope.status.cacheOpenedPanelKey);
            if (angular.isUndefined(tempOpenedPanels)) {
                loadItemsByPage(0);
                return;
            }
            $scope.status.isOpenedPanel = {};
            for (var i in $scope.data.panels) {
                if (tempOpenedPanels[$scope.data.panels[i].DATE + $scope.data.panels[i].BANMIANID] === true) {
                    $scope.status.isOpenedPanel[i] = true;
                    loadItemsByPage(i);
                }
            }
        }

        /**
         * [loadItemsByPage description]假分页
         * @param  {[type]} index    [description] PANEL 下标
         * @param  {[type]} currpage [description] 当前页
         * @return {[type]}          [description]
         */
        function loadItemsByPage(index) {
            var panel = $scope.data.panels[index];
            if (angular.isUndefined(panel)) {return;}
            if (panel.DOCUMENTS.length == panel.DOCCOUNT) {return;}
            var key = panel.BANMIANID + panel.DATE;
            var currpage = $scope.status.cachedPage[key];
            var cache = $cacheFactory.get($scope.status.cachedName);
            var addedItems = cache.get(key).slice(currpage * $scope.page.PAGESIZE, (currpage + 1) * $scope.page.PAGESIZE > panel.DOCCOUNT ? panel.DOCCOUNT : ((currpage + 1) * $scope.page.PAGESIZE));
            panel.DOCUMENTS = $filter('unique')(panel.DOCUMENTS.concat(addedItems), 'METADATAID');
            $scope.status.cachedPage[key] += 1;
        }

        /**
         * [loadMore description]加载更多
         * @param  {[type]} index [description] panel 下标
         * @return {[type]}       [description]
         */
        $scope.loadMore = function (index) {
            loadItemsByPage(index);
        };

        /**
             * [newspaperMultiSelected description]报纸分类多选
             * @param  {[type]} items [description] 对象集合
             * @param  {[type]} index [description] 对象集合
             * @return {[type]}       [description]
             */
        $scope.newspaperMultiSelected = function (items, index) {
            var judgement = determineItemsInSelectedArray(items);
            if (judgement) {
                removeItemsInSelectedArray(items);
                $scope.data.word[index].selcetedWord = 0;
            } else {
                addItemsToSelectedArray(items, index);
                // 选中的报纸的字数
                if (items.length == 0) {
                    $scope.data.word[index].selcetedWord = $scope.data.word[index].wordAllCount;
                } else {
                    var selectedNum = 0;
                    $scope.data.selectedArray.map((item) => {

                        if (items.includes(item)) {
                            selectedNum = selectedNum + Number(item.DOCWORDSCOUNT);
                        }
                    });
                    $scope.data.word[index].selcetedWord = selectedNum;
                }
            }
            $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, $scope.data.panels[index].DOCUMENTS[0].CHANNELID, 'paper.yqg').then(function (data) {
                $scope.status.btnRights = data;
            });
        };

        /**
         * [removeItemsInSelectedArray description] 将对象数组从已选中移除
         * @param  {[array]} items [description] array
         * @return {[type]}       [description]
         */
        function removeItemsInSelectedArray(items) {
            for (var i = 0; i < items.length; i++) {
                if ($scope.data.selectedArray.indexOf(items[i]) > -1) {$scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(items[i]), 1);}
            }
        }

        /**
         * [addItemsToSelectedArray description]；将对象数组加入到已选数组中
         * @param {[type]} items [description] 传入的对象数组
         * @param {[type]} index [description] 
         * @return {[type]}       [description]
         */
        function addItemsToSelectedArray(items, index) {
            if (items.length === 0) {
                $scope.status.isOpenedPanel[index] = true;
                $scope.getCachedById(index);
                items = $scope.data.panels[index].DOCUMENTS;
            }
            for (var i = 0; i < items.length; i++) {
                if ($scope.data.selectedArray.indexOf(items[i]) < 0) {$scope.data.selectedArray.push(items[i]);}
            }
        }
        $scope.determineItemsInSelectedArray = function (items) {
            return determineItemsInSelectedArray(items);
        };

        /**
             * [determineItemsInSelectedArray description] 判断对象全部在已选列表中
             * @param  {[type]} items [description]
             * @return {[object]}       [description]  isAllIn :true 全在；
             */
        function determineItemsInSelectedArray(items) {
            var isAllIn = true;
            if (items.length === 0) {return false;}
            for (var i = 0; i < items.length; i++) {
                if ($scope.data.selectedArray.indexOf(items[i]) < 0) {isAllIn = false;}
            }
            return isAllIn;
        }

        /**
             * [cacheDate description] 缓存数据以提高渲染速度
             * @param  {[type]} data [description]
             * @return {[type]} [description]
             */
        function cacheDate(data) {
            if ($cacheFactory.get($scope.status.cachedName)) {$cacheFactory.get($scope.status.cachedName).destroy();}
            var copyedData = angular.copy(data);
            var cache = $cacheFactory($scope.status.cachedName);
            var documents = [];
            for (var i in copyedData) {
                cache.put(copyedData[i].BANMIANID + copyedData[i].DATE, copyedData[i].DOCUMENTS);
                documents.push(copyedData[i].DOCUMENTS);
                if (i > 0) {copyedData[i].DOCUMENTS = [];}
                $scope.status.cachedPage[copyedData[i].BANMIANID + copyedData[i].DATE] = 0;
            }
            $scope.data.panels = copyedData;
            listItemCache(documents);
        }

        /**
             * [cacheDate description] 缓存存储
             * @param  {[type]} data [description]
             * @return {[type]} [description]
             */
        function listItemCache(data) {
            var cachePreviewMetadataid = [];
            $scope.data.selectedArrayObj = [];
            angular.forEach(data, function (data, index, array) {
                angular.forEach(data, function (_data, _index, _array) {
                    cachePreviewMetadataid.push(_data.METADATAID);
                    $scope.data.selectedArrayObj.push(_data);
                });
            });
            localStorageService.set('newspaperPreviewCache', cachePreviewMetadataid);
        }

        /**
             * [selectedArrayCahe description] 缓存当前选中项
             * @param  {[type]} array [description]选中对象
             * @return {[type]} [description]
            */
        function selectedArrayCahe(array) {
            var selectedArray = angular.copy(array);
            var selectedArrayMetadaid = [];
            angular.forEach(selectedArray, function (data, index) {
                selectedArrayMetadaid.push(data.METADATAID);
            });
            localStorageService.set('newspaperPreviewSelectArray', selectedArrayMetadaid); // paged
        }

        // 监听预览页 按钮点击
        $window.addEventListener('storage', function (e) { // sin
            $scope.data.selectedCurrents = angular.copy(localStorageService.get('newspaperPreviewSelectArray')); // page
            $scope.$apply(function () {
                selectCurArray($scope.data.selectedCurrents);
            });
        });

        /**
             * [selectCurArray description]遍历出选择对象
             *
             * @param   {[type]}  curSelectedArray  [curSelectedArray description]当前选中对象
             *
             * @return  {[type]}                    [return description]
             */
        function selectCurArray(curSelectedArray) { // o
            if (curSelectedArray === null) {return;}
            // var arrays=[];
            $scope.data.selectedArray = [];
            for (var i = 0; i < curSelectedArray.length; i++) {
                for (var j = 0; j < $scope.data.selectedArrayObj.length; j++) {
                    if (curSelectedArray[i] === $scope.data.selectedArrayObj[j].METADATAID) {
                        $scope.data.selectedArray.push($scope.data.selectedArrayObj[j]);
                    }
                }
            }
        }

        /**
             * [selectItem description]单选某稿件
             *
             * @param   {[type]}  item   [item description]
             * @param   {[type]}  items  [items description]
             *
             * @return  {[type]}         [return description]
             */
        $scope.selectItem = function (item, items) {
            var num = -1;
            for (var index = 0; index < $scope.data.selectedArray.length; index++) {
                if ($scope.data.selectedArray[index].METADATAID == item.METADATAID) {
                    num = index;
                    break;
                }
            }
            if (num > -1) {
                $scope.data.selectedArray.splice(num, 1);
            } else {
                $scope.data.selectedArray.push(item);
            }
            // 选中的报纸的字数
            var selectedNum = 0;
            $scope.data.selectedArray.map((item) => {
                if (items.DOCUMENTS.includes(item)) {
                    selectedNum = selectedNum + Number(item.DOCWORDSCOUNT);
                }
            });
            $scope.data.word[$scope.data.panels.indexOf(items)].selcetedWord = selectedNum;

            selectedArrayCahe($scope.data.selectedArray); // si
            $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, items.CHANNELID, 'paper.yqg').then(function (data) {
                $scope.status.btnRights = data;
            });
        };

        /**
             * [selectAllItem description]全选或者取消全选的操作
             *
             * @return  {[type]}  [return description]
             */
        $scope.selectAllItem = function () {
            if ($scope.data.selectedArray.length === $scope.data.yiqianDocsList.length && $scope.data.yiqianDocsList.length > 0) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [];
                for (var i = 0; i < $scope.data.yiqianDocsList.length; i++) {
                    $scope.data.selectedArray.push($scope.data.yiqianDocsList[i]);
                }
            }
            selectedArrayCahe($scope.data.selectedArray);
        };

        /*
         * [isChecked description] 点击单选
         * @item {[type]} [description]  当前选择值
         */
        $scope.isChecked = function (item) { // page
            return getIndex(item) >= 0;
        };

        /**
             * [getIndex description]单选方法
             *
             * @param   {[type]}  item  [item description]当前选择值
             *
             * @return  {[type]}        [return description]
             */
        function getIndex(item) {
            var selectedArray = $scope.data.selectedArray;
            for (var index = 0; index < selectedArray.length; index++) {
                if (selectedArray[index].METADATAID == item.METADATAID) {
                    return index;
                }
            }
            return -1;
        }

        // 导出稿件
        $scope.exportDraft = function () {
            editingCenterService.newsPaperExportDraft($scope);
        };

        $scope.refreshUnreadMessage = function () {
            requestData();
        };

        /**
             * [initDropDown description]
             *
             * @return  {[type]}  [return description]
             */
        function initDropDown() {

            // 初始化选择日期
            $scope.pubTimeArray = initSingleSelecet.newspaperDraftTime();
            $scope.selectdPubTime = angular.copy($scope.pubTimeArray[3]);
            // 初始化选择类型
            $scope.doctypeArray = initSingleSelecet.newspaperDraftType();
            $scope.data.selectedDocType = angular.copy($scope.doctypeArray[0]);
            // 状态
            $scope.docStatusArray = initSingleSelecet.newspaperSignedStatus();
            $scope.selectedDocStatus = angular.copy($scope.docStatusArray[0]);
            // 版面
            // 排序方式
            $scope.sortTypeJsons = initSingleSelecet.sortType();
            $scope.sortType = angular.copy($scope.sortTypeJsons[1]);

            $scope.data.conditionsSearch = editNewspaperService.newspaperEntire();
            $scope.data.selectedConditions = angular.copy(editNewspaperService.newspaperEntire()[0]);
            // editingCenterService.dealStorage($scope);
        }

        /**
         * [getCachedById description]点击版面加载缓存的数据，以提高页面加载速度
         * @param  {[type]} index [description]  panel下标
         * @return {[type]}       [description]
         */
        $scope.getCachedById = function (index) {
            setOpenedPanel(index);
            if ($scope.data.panels[index].DOCUMENTS.length > 0) {return;} else {
                $scope.loadingPromise = loadItemsByPage(index);
            }
        };

        /**
             * [setOpenedPanel description]将panel的开启状态保存到service中
             *
             * @param   {[type]}  index  [index description]
             *
             * @return  {[type]}         [return description]
             */
        function setOpenedPanel(index) {
            for (var i in $scope.status.isOpenedPanel) {
                if (angular.isDefined($scope.data.panels[i])) {
                    $scope.status.cacheOpenedPanel[$scope.data.panels[i].DATE + $scope.data.panels[i].BANMIANID] = $scope.status.isOpenedPanel[i];
                }
            }
            editNewspaperService.cacheOpenedPanel($scope.status.cacheOpenedPanelKey, $scope.status.cacheOpenedPanel);
        }

        /**
             * [newspaperPreview description]报纸预览
             *
             * @param   {[type]}  item  [item description]当前对象
             *
             * @return  {[type]}        [return description]
             */
        $scope.newspaperPreview = function (item) {
            storageListenerService.previewPageTurningStorage($scope.data.yiqianDocsList, 'METADATAID,SITEID,DOCTYPEID', 'newspaperPreview'); // news;
        };

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function (key, value) {// 折叠模式版面筛选不走接口
            if (key === 'ChannelId') {
                $scope.loadingPromise = editNewspaperService.getBMRights($scope.data.AllBMRights, value, $stateParams.paperid, 'paper.yqg').then(function (data) {
                    $scope.status.btnRights = data;
                });
            }
            if (key === 'ChannelId' && !$scope.status.isShowList) {
                return;
            } else if (key === 'PubDate' && value) {
                value = $filter('date')(value, 'yyyy-MM-dd');
            }
            if (key === 'DocType' && value === '2') {
                $scope.status.hasphotoflag = true;
            }
            $scope.params[key] = value;
            $scope.page.CURRPAGE = 1;
            // if (key == 'DocPubTime') {
            //     if (value.length < 10) {
            //         $scope.params.OprTimeStart = null;
            //         $scope.params.OprTimeEnd = null;
            //     } else {
            //         $scope.params.OprTimeStart = $scope.data.fromdate;
            //         $scope.params.OprTimeEnd = $scope.data.untildate;
            //         $scope.params[key] = null;
            //     }
            // }
            requestData();
        };

        /**
         * [clearDateTime description] 清空时间
         *
         * @return  {[type]}  [return description]
         */
        $scope.clearDateTime = function () {
            $scope.data.pubDate = '';
            $scope.queryByDropdown('PubDate');
        };

        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function (item) {
            $scope.selectItemList(item);
        };

        /**
         * [atlasMode description] 图集模式
         * @return {[type]} [description]
         */
        $scope.atlasMode = function () {
            // $scope.departListParams.CurrPage = $scope.page.CURRPAGE = 1;
            $scope.status.hasphoto = !$scope.status.hasphoto;
            $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
        };

        /**
         * [goToDetail description]图集模式跳转细览页
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.goToDetail = function (item) {
            $scope.newspaperPreview(item);
            var params = {
                paperid: item.SITEID,
                bzmetadata: item.METADATAID,
                newspapertype: $scope.status.yqgpreview,
                channelid: item.CHANNELID
            };
            var url = $state.href('newspaperNewsPreview', params);
            window.open(url);
        };


        // 稿件关联弹窗
        $scope.draftCorrelationView = function (item) {
            editNewspaperService.draftCorrelationViews(item.METADATAID, $stateParams.paperid, 3);
        };

        // 批量取消签发
        $scope.cancelSignedView = function () {
            isAcross($scope.data.selectedArray).then(function () {
                cancelSignedDraft($scope.data.selectedArray);
            });
        };
        // 单个取消签发
        $scope.cancelSignedQF = function (item) {
            isAcross([item]).then(function () {
                cancelSignedDraft([item]);
            });
        };

        /**
        * [cancelSignedDraft description]取消签发方法
        * @param   {[array]}  gather  [item description] 稿件集合
        * @return  {[type]}           [return description]
        */
        function cancelSignedDraft(gather) {
            const chnlDocIds = gather.map((item) => item.CHNLDOCID).join(',');
            editingCenterService.isListDocCanOper(chnlDocIds, $scope.requestData).then(() => {
                var transferData = {
                    'title': '取消签发',
                    'opinionTit': '取消签发意见',
                    'items': gather,
                    'PaperId': $state.params.paperid,
                    'queryMethod': $scope.params.methodname
                };
                editNewspaperService.cancelSignedViews(transferData, (result) => {
                    var params = {
                        'SrcDocIds': result.SrcDocIds,
                        'Option': result.opinion ? result.opinion : '',
                        'serviceid': 'mlf_paper',
                        'methodname': 'doQuXiaoQF'
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(() => {
                        modalDialog.alertType('取消签发成功', '', 'success', false, function () {
                            requestData();
                        });
                    }, () => {
                        requestData();
                    });
                });
            });
        }

        /**
         * [isAcross description] 判断是否含有跨版转版的稿件
         * @param  {[type]}  item   [item description]
         * @return  {[type]}   [return description]
         */
        function isAcross(item) {
            var defer = $q.defer();
            var items = [];
            for (var i = 0; i < item.length; i++) {
                if (item[i].FLAG === '1') {
                    items.push(item[i]);
                }
            }
            if (items.length) {
                editNewspaperService.acrossAlert(items).then(function () {
                    defer.resolve();
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        // 稿件收藏
        $scope.batchCollect = function () {
            editNewspaperService.collectDraft($scope, 'collectYiQianFa');
        };

        /**
             * [printBtn description]批量打印功能
             *
             * @return  {[type]}  [return description]
             */
        $scope.printBtn = function () {
            const chnlDocIds = $scope.data.selectedArray.map((item) => item.CHNLDOCID).join(',');
            editingCenterService.isListDocCanOper(chnlDocIds, $scope.requestData).then(function (data) {
                var chnlDocIdsArray = trsspliceString.spliceString($scope.data.selectedArray,
                    'METADATAID', ',');
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: 'queryViewDatas',
                    MetaDataIds: chnlDocIdsArray
                };

                /**
                     * [requestVersion description]
                     *
                     * @return  {[type]}  [return description]
                     */
                function requestVersion() {
                    var idsArray = trsspliceString.getArrayString($scope.data.selectedArray, 'METADATAID', ',').split(',');
                    var versionResult = {};
                    var count = 0;
                    var defer = $q.defer();
                    angular.forEach(idsArray, function (value, key) {
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), {
                            serviceid: 'mlf_metadatalog',
                            methodname: 'query',
                            MetaDataId: value
                        }, 'get').then(function (data) {
                            versionResult[value] = data.DATA;
                            count++;
                            if (count == idsArray.length) {
                                defer.resolve(versionResult);
                            }
                        });
                    });
                    return defer.promise;
                }
                $scope.loadingPromise = $q.all([trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get'), requestVersion()]).then(function (data) {
                    var detail = data[0];
                    var version = data[1];
                    for (var i = 0; i < detail.length; i++) {
                        detail[i].VERSION = version[detail[i].METADATAID];
                        if (i + 1 === detail.length) {
                            trsPrintService.trsPrintDocument(detail);
                        }
                    }
                });
            });
        };

        /**
        * [collectDraft description]收藏稿件方法
        * @param   {[type]}  array  [array description]
        * @return  {[type]}         [return description]
        */
        function collectDraft(array) {
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'collectYiQianFa',
                MetaDataIds: array
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                .then(function (data) {
                    modalDialog.alertType('收藏成功', '', 'success', false);
                    $scope.data.selectedArray = [];
                });
        }


        // 流程版本与操作日志
        $scope.showVersionTime = function (item) {
            editingCenterService.getVersionTime(item, false);
        };

        /**
             * [fullTextSearch description]全文检索
             *
             * @param   {[type]}  ev  [ev description]按下空格也能提交
             *
             * @return  {[type]}      [return description]
             */
        $scope.fullTextSearch = function (ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = 1;
                $scope.status.isESSearch = true;
                $scope.status.isOpenedPanel = {};
                requestData(); // sin
            }
        };

        /**
         * [getESSearchParams description]设置ES检索参数qianfa
         * @return {[json]} [description] 参数对象
         */
        function getESSearchParams() {
            var esParams = {
                serviceid: 'mlf_hybasesearch',
                methodname: $scope.status.isShowList ? 'queryPaperPaperYiQianDocNoPage' : 'queryForPaperYiQianDoc',
                searchParams: {
                    PAGESIZE: $scope.page.PAGESIZE + '',
                    PAGEINDEX: $scope.page.CURRPAGE + '',
                    searchFields: [{
                        searchField: $scope.data.selectedConditions.value,
                        keywords: $scope.status.keywords ? $scope.status.keywords : ''
                    }, {
                        searchField: 'docType',
                        keywords: $scope.data.selectedDocType.value
                    }, {
                        searchField: 'paperid',
                        keywords: $stateParams.paperid
                    }, {
                        searchField: '_sort',
                        keywords: $scope.sortType.value
                    }, {
                        searchField: 'OPERUSER',
                        keywords: $scope.data.selectedSigner.value
                    }, {
                        searchField: 'PubDate',
                        keywords: $scope.data.pubDate ? $filter('date')($scope.data.pubDate, 'yyyy-MM-dd') : ''
                    }]
                }
            };
            if ($scope.status.isShowList) {
                esParams.searchParams.searchFields.push({
                    searchField: 'CHANNELID',
                    keywords: $scope.data.BanMian.selectedBanMian.CHANNELID
                });
            }
            esParams.searchParams = JSON.stringify(esParams.searchParams);
            return esParams;
        }

        // 外发
        $scope.outSending = function () {
            editingCenterService.outSending($scope.data.selectedArray, function (result) {
                outSendingDraft(result.selectItems);
            }, function () {
                $scope.requestData();
            });
        };

        /**
             * [outSendingDraft description]
             *
             * @param   {[type]}  items  [items description]
             *
             * @return  {[type]}         [return description]
             */
        function outSendingDraft(items) {
            var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
            var draftids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
            var params = {
                serviceid: 'mlf_mailoutgoingOper',
                methodname: 'paperYiQianGaoSendEmail',
                Emails: userids,
                MetaDataIds: draftids
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                modalDialog.alertType('邮件外发成功', '', 'success', false);
                $scope.data.selectedArray = [];
            });
        }
        $scope.closeAllPanel = function () {
            angular.forEach($scope.data.panels, function (value, index) {
                $scope.status.isOpen[index] = false;
            });
        };

        /**
             * [isLockEdit description]编辑前请求解锁1
             *
             * @param   {[type]}  item  [item description]稿件对象
             *
             * @return  {[type]}        [return description]
             */
        $scope.isLockEdit = function (item) {
            editIsLock.isLock(item, 3).then(function (data) {
                var editPath = $scope.status.newspaperEdit[item.DOCTYPEID];
                var editParams = {
                    papermetadataid: item.METADATAID,
                    paperid: item.SITEID,
                    newspapertype: $scope.status.yqedit
                };
                var editUrl = $state.href(editPath, editParams);
                if (data.ISLOCK == 'false') {
                    $window.open(editUrl);
                } else {
                    editIsLock.checkUnlockPermissions(item, data).then(function () {
                        $window.open(editUrl);
                    });
                }
            });
        };

        /**
         * [tenantManuShare 租户间共享]
         * @return {[type]} [description]
         */
        $scope.tenantManuShare = function () {
            const chnlDocIds = $scope.data.selectedArray.map((item) => item.CHNLDOCID).join(',');
            editingCenterService.isListDocCanOper(chnlDocIds, $scope.requestData).then(function (data) {
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: 'pluralisticShare',
                    dataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    PaperId: $stateParams.paperid,
                };
                editingCenterService.tenantShareManu(params).then(function (data) {
                    if (data == 'success') {
                        requestData();
                        $scope.data.selectedArray = [];
                    }
                });
            });
        };

        /**
         * [tenantManuShare 共享到已定稿库]
         * @return {[type]} [description]
         */
        $scope.shareToYd = function () {
            const chnlDocIds = $scope.data.selectedArray.map((item) => item.CHNLDOCID).join(',');
            editingCenterService.isListDocCanOper(chnlDocIds, $scope.requestData).then(function (data) {
                var reviewArray = $scope.data.selectedArray.filter(function (item) {
                    return item.ISSHARE === '1';
                });
                if (reviewArray.length > 0) {
                    modalDialog.alertType('所选稿件中含有共享过的稿件，不能再次共享', '', 'warning', 'cancel');
                    return;
                }
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: 'ydShare',
                    DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                };
                editingCenterService.shareToYd(params).then(function (data) {
                    if (data == 'success') {
                        requestData();
                        $scope.data.selectedArray = [];
                    }
                });
            });
        };

        /**
        * [zhuanban description] 转版
        * @return  {[type]}  [return description]
        */
        $scope.zhuanban = function () {
            let banmianMethodName = $scope.data.paperMsg.ISZHAOPAI === '0' ? 'queryCaiBianBanMians' : 'queryZhaoPaiBanMians'; // 只有已签稿的转版区分采编跟照排版面，其余不区分
            newMediaService.zhuanBan($scope, banmianMethodName);
        };

        /**
         * [banmianFilter description] 版面过滤器
         * @param   {[object]}  elm  [elm description] 稿件对象
         * @return  {[type]}         [return description]
         */
        $scope.banmianFilter = function (elm) {
            if (angular.isDefined(elm.CHNLID)) {
                return elm.CHNLID === $scope.data.selectedArray[0].CHNLID;
            }
        };


        /** *************************list模式方法**************************/

        /**
         * [pageChanged description] 换页
         *
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function () {
            requestData();
        };

        /**
         * [selectAllList description] 全选
         *
         * @return  {[type]}  [return description]
         */
        $scope.selectAllList = function () {
            $scope.data.selectAllWords = 0;
            if ($scope.data.selectedArray.length === $scope.data.panels.length) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [].concat($scope.data.panels);
                $scope.data.panels.forEach(function (item) {
                    $scope.data.selectAllWords += parseInt(item.DOCWORDSCOUNT);
                });
            }
        };

        /**
         * [selectItemList description] 单选
         *
         * @param   {[type]}  item   [item description]
         * @param   {[type]}  index  [index description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.selectItemList = function (item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index === -1) {
                $scope.data.selectedArray.push(item);
                $scope.data.selectAllWords += parseInt(item.DOCWORDSCOUNT);
            } else {
                $scope.data.selectedArray.splice(index, 1);
                $scope.data.selectAllWords -= parseInt(item.DOCWORDSCOUNT);
            }
            $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, item.CHANNELID, 'paper.yqg').then(function (data) {
                $scope.status.btnRights = data;
            });
        };

        /**
         * [changeMode description] 切换时折叠模式还是列表模式
         *
         * @return  {[type]}  [return description]
         */
        $scope.changeMode = function () {
            // $scope.page.PAGESIZE = 50;
            $scope.page.CURRPAGE = 1;
            $scope.data.panels = [];
            $scope.status.isShowList = !$scope.status.isShowList;
            requestData();
        };

        /**
         * [distribute 多元分发]
         *
         * @return  {[type]}  [return description]
         */
        $scope.distribute = function () {
            $scope.status.isESSearch = false;
            if (!editingCenterService.isSameDocType($scope.data.selectedArray, 'DOCTYPEID')) {
                modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () { });
                return;
            }
            var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
            if (temp.length < 1) {
                editingCenterService.distribution($scope.data.selectedArray, '3', $scope.data.selectedArray[0].DOCTYPEID, 'paperYiQianFaDistribute', function () {
                    $scope.data.selectedArray = [];
                });
            } else {
                modalDialog.alertType('', '多元分发仅支持的稿件类型为新闻', 'warning', 'confirm', function () { });
            }
        };

        /**
         * [examDistributionType description]多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
         *
         * @param   {[type]}  elm  [elm description]
         *
         * @return  {[type]}       [return description]
         */
        $scope.examDistributionType = function (elm) {
            if (angular.isDefined(elm)) {
                return elm.DOCTYPEID != 1;
            }
        };
    }
]);
